export default __webpack_public_path__ + "static/media/leaf.bd47293e.svg";